<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <h1>Tutorial</h1>
        <h2>Navigating FIVEx's single variant view</h2>
        <p>          
          <video
            controls
            src="../../media/FIVEx_tutorial_1.mp4"
            type="video/mp4"
          >
            Your browser does not support the HTML5 Video element.
          </video>
        </p>
        <h2>Using the buttons on the single-variant page</h2>
        <p>
          <video
            controls
            src="../../media/FIVEx_tutorial_2.mp4"
            type="video/mp4"
          >
            Your browser does not support the HTML5 Video element.
          </video>
        </p>
        <h2>Using filters with user-chosen thresholds and the table in single variant view</h2>
        <p>
          <video
            controls
            src="../../media/FIVEx_tutorial_3.mp4"
            type="video/mp4"
          >
            Your browser does not support the HTML5 Video element.
          </video>
        </p>
        <h2>Switching between eQTLs and sQTLs</h2>
        <p>
          <video
            controls
            src="../../media/FIVEx_tutorial_4.mp4"
            type="video/mp4"
          >
            Your browser does not support the HTML5 Video element.
          </video>
        </p>
        <h2>FIVEx's region view</h2>
        <p>
          <video
            controls
            src="../../media/FIVEx_tutorial_5.mp4"
            type="video/mp4"
          >
            Your browser does not support the HTML5 Video element.
          </video>
        </p>
        <h2>Region view table, and moving between single variant and region views</h2>
        <p>
          <video
            controls
            src="../../media/FIVEx_tutorial_6.mp4"
            type="video/mp4"
          >
            Your browser does not support the HTML5 Video element.
          </video>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Tutorial',
};
</script>

<style scoped>

</style>
